import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import AppLogo from '@/components/ui/AppLogo/AppLogo.tsx';

type BrandCardSideContentProps = PropsWithChildren<
  PropsWithClassName & {
    centerContent?: boolean;
  }
>;

const BrandCardSideContent: FC<BrandCardSideContentProps> = ({ children, className, centerContent = false }) => {
  return (
    <div
      className={cn(
        'flex flex-col md:flex-row shadow-xl rounded-2xl overflow-hidden max-w-full w-[1048px] min-h-[500px] lg:min-h-[624px]',
        className
      )}
    >
      <div
        className="hidden md:flex flex-col items-center justify-center gap-3 p-10 w-1/2 shrink-0"
        style={{ background: 'linear-gradient(180deg, #0F1B2A 0%, #1A5292 126.68%)' }}
      >
        <AppLogo.Default className="w-[220px]" />
      </div>

      <div
        className={cn(
          'flex flex-col flex-1 items-start p-8 lg:p-10 bg-white',
          centerContent && 'justify-center'
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default BrandCardSideContent;
